import { connect } from "react-redux";
import { PageSelectOrganization } from "senac-components";
import { commonSlice, userSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  PageSelectOrganizationPropsDispatch,
  PageSelectOrganizationPropsState,
} from "senac-components/dist/pages/Mobile/PageSelectOrganization";
import { PageSelectOrganizationWeb } from "senac-components/dist/pages/Web/PageSelectOrganization";
import {
  MenuOptions,
  ProjectItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";

const mapState = (state: RootState) => {
  let result: PageSelectOrganizationPropsState = {
    loading: false,
    projects: state.userState.projectsAvailable,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageSelectOrganizationPropsDispatch = {
    onClickNext: (project: ProjectItem) =>
      dispatch(userSlice.actions.selectProject(project)),
    onClickCollection: () =>
      dispatch(commonSlice.actions.goToPage(MenuOptions.Home)),
    onClickForgotMyPassword: () =>
      dispatch(commonSlice.actions.recoverPassword()),
  };

  return result;
};

const WPageSelectOrganization = () => {
  const Mobile = connect(mapState, mapDispatch)(PageSelectOrganization);
  const Web = connect(mapState, mapDispatch)(PageSelectOrganizationWeb);

  if (window.innerWidth <= 1024) return <Mobile />;
  return <Web />;
};

export { WPageSelectOrganization };
